/* Cloud Nine Pajamas: compact quick add (Oct 2026) */
(function () {
  if (window.c9QuickAddModal) return;
  window.c9QuickAddModal = true;

  var cartAdd = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
  var money = function (cents) {
    return (cents / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' });
  };
  var lastFocus = null;
  var state = null;

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  // One shared dialog
  var overlay = el('div', 'c9q-overlay');
  overlay.hidden = true;
  var dialog = el('div', 'c9q');
  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-modal', 'true');
  dialog.setAttribute('aria-labelledby', 'c9q-title');
  overlay.appendChild(dialog);

  function close() {
    overlay.hidden = true;
    document.documentElement.classList.remove('c9q-open');
    dialog.innerHTML = '';
    state = null;
    if (lastFocus) lastFocus.focus();
  }
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })); }, 300);
  }

  function addToCart(variantId, btn, label) {
    if (btn) { btn.disabled = true; btn.textContent = btn.classList.contains('c9-qa-btn') ? '\u2026' : 'Adding\u2026'; }
    return fetch(cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      if (btn) btn.textContent = btn.classList.contains('c9-qa-btn') ? '\u2713' : 'Added \u2713';
      if (!overlay.hidden) close();
      refreshCart();
      if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2000);
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      var msg = dialog.querySelector('.c9q-msg');
      if (msg) msg.textContent = err.message;
      else alert(err.message);
    });
  }

  function findVariant() {
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === state.sel[i]; });
    });
  }

  function valueAvailable(optIndex, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || i > optIndex || o === state.sel[i]; });
    });
  }

  function render() {
    var p = state.product;
    var v = findVariant();
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '$1$2').split('?')[0] + '?width=300';
    dialog.innerHTML = '';
    var closeBtn = el('button', 'c9q-close', '&times;');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.addEventListener('click', close);
    dialog.appendChild(closeBtn);

    var head = el('div', 'c9q-head');
    if (img) { var im = el('img', 'c9q-img'); im.src = img; im.alt = ''; im.width = 90; im.height = 90; head.appendChild(im); }
    var info = el('div', 'c9q-info');
    var t = el('p', 'c9q-title'); t.id = 'c9q-title'; t.textContent = p.title; info.appendChild(t);
    var pr = el('p', 'c9q-price');
    if (v) {
      pr.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var was = el('s', 'c9q-was'); was.textContent = money(v.compare_at_price); pr.appendChild(document.createTextNode(' ')); pr.appendChild(was);
      }
    }
    info.appendChild(pr);
    head.appendChild(info);
    dialog.appendChild(head);

    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var fs = el('fieldset', 'c9q-opt');
      var lg = el('legend', 'c9q-legend');
      lg.innerHTML = name + ': <strong>' + (state.sel[i] || '') + '</strong>';
      fs.appendChild(lg);
      var wrap = el('div', 'c9q-vals');
      var values = [];
      p.variants.forEach(function (vv) { if (values.indexOf(vv.options[i]) === -1) values.push(vv.options[i]); });
      values.forEach(function (val) {
        var b = el('button', 'c9q-val');
        b.type = 'button';
        b.textContent = val;
        var ok = valueAvailable(i, val);
        if (!ok) { b.classList.add('is-out'); b.setAttribute('aria-disabled', 'true'); }
        if (state.sel[i] === val) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); } else { b.setAttribute('aria-pressed', 'false'); }
        b.addEventListener('click', function () {
          if (!ok) return;
          state.sel[i] = val;
          // keep later options valid
          for (var j = i + 1; j < state.sel.length; j++) {
            if (!valueAvailable(j, state.sel[j])) {
              var firstOk = p.variants.find(function (vv) { return vv.available && vv.options.slice(0, j).every(function (o, k) { return o === state.sel[k]; }); });
              if (firstOk) state.sel[j] = firstOk.options[j];
            }
          }
          render();
          var again = dialog.querySelector('.c9q-val.is-on');
          if (again) again.focus();
        });
        wrap.appendChild(b);
      });
      fs.appendChild(wrap);
      dialog.appendChild(fs);
    });

    var msg = el('p', 'c9q-msg'); msg.setAttribute('role', 'status'); dialog.appendChild(msg);
    var add = el('button', 'c9q-add');
    add.type = 'button';
    var label = v && v.available ? 'Add to cart \u2014 ' + money(v.price) : 'Sold out';
    add.textContent = label;
    add.disabled = !(v && v.available);
    add.addEventListener('click', function () { if (v) addToCart(v.id, add, label); });
    dialog.appendChild(add);

    var more = el('a', 'c9q-more', 'View full details');
    more.href = state.url;
    dialog.appendChild(more);
  }

  function open(handle, url, trigger) {
    lastFocus = trigger;
    var label = trigger.innerHTML;
    trigger.disabled = true;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) {
        trigger.disabled = false;
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!avail.length) { window.location.href = url; return; }
        if (p.variants.length === 1) { addToCart(p.variants[0].id, trigger, label); return; }
        state = { product: p, url: url, sel: avail[0].options.slice() };
        if (!overlay.parentNode) document.body.appendChild(overlay);
        overlay.hidden = false;
        document.documentElement.classList.add('c9q-open');
        render();
        var first = dialog.querySelector('.c9q-val.is-on') || dialog.querySelector('.c9q-add');
        if (first) first.focus();
      })
      .catch(function () { trigger.disabled = false; window.location.href = url; });
  }

  // Trap focus inside the dialog
  dialog.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = dialog.querySelectorAll('button:not([disabled]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.c9-qa-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b.getAttribute('data-handle'), b.getAttribute('data-url'), b);
  }, true);
})();
